var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon, _polygon2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.18 336.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#812990;}.cls-3{fill:#f04e23;}.cls-4{fill:#fff;}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{stroke:#fbb040;}.cls-6{stroke:#6b7b84;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.3,335.41l.3-.34a2.19,2.19,0,0,0,1.67.77c1.09,0,1.4-.6,1.4-1.06,0-1.57-3.2-.75-3.2-2.62a1.56,1.56,0,0,1,1.75-1.42,2.31,2.31,0,0,1,1.81.75l-.3.34a1.93,1.93,0,0,0-1.53-.67c-.71,0-1.25.4-1.25,1,0,1.37,3.2.62,3.2,2.61,0,.68-.46,1.51-1.89,1.51A2.49,2.49,0,0,1,.3,335.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.12,331.37a.32.32,0,0,1,.32-.31.32.32,0,1,1,0,.63A.32.32,0,0,1,5.12,331.37Zm.11,4.79V332.3h.42v3.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.74,336.16v-.34L9,332.67H6.74v-.37H9.57v.34l-2.31,3.15H9.6v.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.48,334.23a1.92,1.92,0,0,1,1.85-2,1.85,1.85,0,0,1,1.83,2.05v.11H10.93a1.51,1.51,0,0,0,1.51,1.54,1.7,1.7,0,0,0,1.26-.54l.22.27a2,2,0,0,1-1.51.63A1.9,1.9,0,0,1,10.48,334.23Zm1.85-1.67a1.46,1.46,0,0,0-1.4,1.48h2.8A1.41,1.41,0,0,0,12.33,332.56Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.1,332.6a.36.36,0,0,1,.36-.36.35.35,0,0,1,.35.36.35.35,0,0,1-.35.34A.36.36,0,0,1,15.1,332.6Zm0,3.28a.36.36,0,0,1,.36-.34.35.35,0,1,1,0,.69A.36.36,0,0,1,15.1,335.88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.73,336.16v-4.71l-.85.91-.28-.29,1.17-1.24h.42v5.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.32,333.5c0-1.37.57-2.75,2-2.75a1.72,1.72,0,0,1,1.44.68l-.27.33a1.33,1.33,0,0,0-1.17-.59c-1.15,0-1.58,1.2-1.58,2.34a2.09,2.09,0,0,0,0,.25,2,2,0,0,1,1.56-.89,1.58,1.58,0,0,1,1.72,1.69,1.7,1.7,0,0,1-1.79,1.7C21.84,336.26,21.32,334.93,21.32,333.5Zm3.28,1.06a1.2,1.2,0,0,0-1.33-1.28,1.75,1.75,0,0,0-1.46.91c.07.72.45,1.65,1.45,1.65A1.28,1.28,0,0,0,24.6,334.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.05,332.6a.36.36,0,1,1,.71,0,.36.36,0,0,1-.71,0Zm0,3.28a.36.36,0,1,1,.36.35A.35.35,0,0,1,26.05,335.88Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,335.57l.27-.33a1.35,1.35,0,0,0,1.17.59c1.17,0,1.58-1.22,1.58-2.34v-.25a2,2,0,0,1-1.57.89,1.58,1.58,0,0,1-1.72-1.69,1.7,1.7,0,0,1,1.79-1.7c1.44,0,2,1.33,2,2.76s-.57,2.75-2,2.75A1.7,1.7,0,0,1,28,335.57Zm3-2.76c-.06-.73-.44-1.65-1.44-1.65a1.28,1.28,0,0,0-1.35,1.28,1.21,1.21,0,0,0,1.34,1.28A1.72,1.72,0,0,0,31,332.81Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.74,167.5V151.75h8.41c3.68,0,5.67,2.46,5.67,5.41s-2,5.38-5.67,5.38h-3.64v5ZM202,157.16c0-.85-.63-1.25-1.44-1.25h-3v2.48h3C201.34,158.39,202,158,202,157.16Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.05,167.5l-2.18-5h-1.72v5h-4.77V151.75h8.41c3.68,0,5.67,2.46,5.67,5.41a5.08,5.08,0,0,1-2.84,4.77l2.86,5.57Zm.56-10.37c0-.85-.75-1.22-1.56-1.22h-2.9v2.48h2.9C216.86,158.39,217.61,158,217.61,157.13Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.4,167.5V151.75h11.95v4.16h-7.18v1.56h7v4.15h-7v1.73h7.18v4.15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.27,165.28l2.48-3.54a7.35,7.35,0,0,0,5.08,2c.9,0,1.75-.23,1.75-.85,0-1.51-8.79,0-8.79-6.19,0-2.67,2.22-5.22,6.54-5.22a10.38,10.38,0,0,1,6.69,2.2l-2.55,3.38a8,8,0,0,0-4.63-1.56c-1,0-1.21.31-1.21.71,0,1.48,8.77.21,8.77,6.07,0,3.47-2.58,5.48-6.81,5.48A10.35,10.35,0,0,1,237.27,165.28Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253,167.5V151.75h12v4.16h-7.18v1.56h7v4.15h-7v1.73h7.18v4.15Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.62,167.5l-5.81-8v8H267V151.75H272l5.48,7.46v-7.46h4.77V167.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.13,167.5V155.91h-4.22v-4.16h13.2v4.16h-4.2V167.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.91,167.5l-.57-1.84h-5.67l-.57,1.84h-5.4l5.81-15.75h6l5.81,15.75Zm-3.4-11.07L303,161.5h3.11Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.13,167.5V155.91H311.9v-4.16h13.2v4.16h-4.2V167.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.81,167.5V151.75h4.77V167.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.28,159.64c0-4.84,3.76-8.15,8.62-8.15s8.62,3.31,8.62,8.15-3.75,8.15-8.62,8.15S333.28,164.48,333.28,159.64Zm12.4,0a3.78,3.78,0,1,0-3.78,3.94A3.73,3.73,0,0,0,345.68,159.64Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.81,167.5l-5.81-8v8h-4.77V151.75h4.91l5.48,7.46v-7.46h4.77V167.5Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.35,167.5V155.91h-4.23v-4.16h13.2v4.16h-4.2V167.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390,167.5V151.75h4.77V167.5Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.73,167.5V155.91H396.5v-4.16h13.2v4.16h-4.2V167.5Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.41,167.5V151.75h4.77v11.6h6v4.15Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424.07,167.5V151.75H436v4.16h-7.18v1.56h7v4.15h-7v1.73H436v4.15Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "143.63 319.06 95.79 239.33 47.96 319.06 143.63 319.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.13 0.16 47.96 0.16 143.63 159.61 47.96 319.06 0.13 319.06 0.13 0.16"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.08,175.11l-.91.13a2.93,2.93,0,0,1-.45.1c-.34,0-.52-.44-1-.54-.12,0,0,0-.18-.05s.06,0-.23-.11c0,.31-.07.22-.07.47a1.77,1.77,0,0,0,.2.82c.09.18.13.12.12.38a1.62,1.62,0,0,0,.14,1,2.75,2.75,0,0,1,.36.73c.48,0,.41,0,.47.14.44,0,.15-.1.4-.14,0,0,.46.11.34-.46.34.09.18.27.4.25s.09-.17.12-.38-.09-.06.23-.21l-.07-.41c0-.47.11,0,.27.07l.19-1.42c0-.11.15-.06-.13-.47C49,175.08,49.15,175.09,49.08,175.11Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.21,173.9c-.05.19.1.11-.13.13l.26.61c.12-.06.08,0,.27-.06,0-.42,0-.27-.14-.48S49.38,173.94,49.21,173.9Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.83,173.36c-.07.28,0,0-.09.22s-.12.6.28.38C46,173.49,46.07,173.53,45.83,173.36Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.62,168.57a2.49,2.49,0,0,0-.83.13c-.49.13-.27.24-.12.48a3,3,0,0,0,1.18-.17c.22,0,.24,0,.11-.24h-.34Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.3,165.26a1.55,1.55,0,0,0-.06-.23l-.77-.29c-.55-.2-1.1-.4-1.63-.62s-1.11-.45-1.72-.76-1.32-.66-2-1.08a4.6,4.6,0,0,1-1.64-1.86,7.36,7.36,0,0,1-.37-.94H46a4,4,0,0,0-.74.09l-.7.18a9.05,9.05,0,0,1-1.89.36h-.24l-.72,0a4.33,4.33,0,0,1-.53,0,10,10,0,0,1-1.14-.2l-.39-.09c-.1.13-.2.25-.31.37a.76.76,0,0,1,.21.19,1.35,1.35,0,0,1,.28,1.32,2,2,0,0,1-1.76,1.3c-.23,0-.44,0-.65,0h-.11a2.17,2.17,0,0,1-1.73-1.14,1.53,1.53,0,0,1,.12-1.7l0,0,.29-.42a4.84,4.84,0,0,0,.31-.49l.18-.36a2.3,2.3,0,0,1-2-1.47,4.89,4.89,0,0,1-.3-1.41L34,156l-.31.08a2.71,2.71,0,0,1-.26.29,1.76,1.76,0,0,1-1.21.57,1.6,1.6,0,0,1-.47-.08h-.08a1.54,1.54,0,0,1-.89-.28,1.14,1.14,0,0,1-.51-.35,1.19,1.19,0,0,1-.23-1,4.33,4.33,0,0,1,.77-1.67l.1-.13a1.56,1.56,0,0,1,.47-1c.2-.2.41-.38.61-.55l.17-.14a3.47,3.47,0,0,1,.33-.26,2,2,0,0,1,.33-.9A3.73,3.73,0,0,1,34,149.51c.24-.15.47-.28.69-.4l.34-.19.32-.19.18-.11a1,1,0,0,1,.53-.16,1.13,1.13,0,0,1,.44.1,1.06,1.06,0,0,1,.58,1.22s-.26.89-.34,1.18a2.76,2.76,0,0,1-.5.94,7.77,7.77,0,0,1,.73.49,5.16,5.16,0,0,1,.58.55H38l.15,0a3.59,3.59,0,0,0,1.07-.49l.15-.09a8.94,8.94,0,0,1,2.11-1,14.37,14.37,0,0,1,3.73-.53h.5c.69,0,1.38,0,2,.07a12,12,0,0,1,1.55.21A9.1,9.1,0,0,1,53,152.7a.68.68,0,0,0-.37-.52c-.19-.09-.1,0-.23-.12l0,0-.15-.12c-.24-.15-.2,0-.29-.32l-.09,0,0,0c-.15,0-.1-.27-.24-.44s.06.13-.29-.05c-.19-.09,0,0-.11-.08A.3.3,0,0,0,51,151l-.12,0c-.55-.23-.45-.32-.45-.88-.48-.13-.19-.49-.16-.8.06-.5-.24-.56-.12-1.09-.67,0-.4-.67-.59-1.38l0-.65c0-.14,0,.06.08-.19l-.18-.09c-.63-.38-.5-.67-.69-.79l-.47.15c-.14.1,0,.07-.21.12-.44-.42-.24-1.29-.39-1.85-.05-.23-.1-.56-.42-.64a1,1,0,0,1,.2-.41c-.16-.08-.24-.06-.4-.14a2,2,0,0,0-.21-1.08c-.13-.21,0-.23-.34-.26-.08.31,0,.13-.34.26a2,2,0,0,1-.24,1l0,0-.06.08a1.34,1.34,0,0,0-.28.67h.2c0,.3,0,.13-.15.31s-.08,0,0,.34-.24.38-.21.75.11.17.1.41-.07.2-.06.39c0,.5.21.37,0,.86s-.15,1-.46,1.49a6.49,6.49,0,0,0-.35.74,1,1,0,0,1-.76.29,3.1,3.1,0,0,1-.69-.33c-.13-.07-.23-.11-.29-.24s0-.09-.07-.2c-.16-.34-.61-.31-.93-.42s-.44-.58-1.21-.89l-.41-.12-.32-.22-.26-.29c-.08-.07-.21-.15-.31-.23l-.29-.18c-.27-.14-.23,0-.24-.37.15-.05.32-.33.45-.51s0,0,.08-.12l.06-.15s0,0,0,0,.1-.25.13-.34c-.27-.11,0,.05-.26-.07.11-.16.08-.07.14-.27.34-.17.25-.07.46,0,.41-.59.17-.22.26-.56s.28-.36.42-.58l-.25-.16c-.28-.14-.22.11-.22-.38a1.33,1.33,0,0,0-.55.4c-.06-.09-.06.14-.06-.19a1.35,1.35,0,0,1-.34.12c.2-.25.11,0,.21-.26a1.84,1.84,0,0,0-.89.33c-.17-.12-.27-.11-.34-.33-.33,0-.09,0-.39.14a1.59,1.59,0,0,0-.55-.28v-.13c-.36,0-.6.23-.9-.12,0,0-.15-.25-.18-.29-.25.07-.14.07-.34.2a.5.5,0,0,0-.3-.37c-.11-.07,0,0-.14-.05l-.38,0s.1,0-.2.05v.21c.26.06,0,0,.19.08l0,0,0,0c.2.09.22,0,.54,0a1.54,1.54,0,0,1,.13.62l-.5.16,0,0-.6.07c-.26,0-.17-.06-.27-.25l-.18.08-.17.1c-.2.15.1.06-.23.18a.63.63,0,0,1-.31,0c0,.18,0,.17-.15.39s0,.2-.32.23c0,.48.05.2.14.53l-.22.08c-.34.08-.18.08-.3.42s-.29.1-.43.72c.22.15.27.15.31.29a.51.51,0,0,1,0,.24c-.65-.05-.36,0-.6,0a2.47,2.47,0,0,0-.75-.11c0,.49,0,.15-.14.28l0,0-.1.16c0-.46.1-.14.13-.53-.57-.16-.55-.77-1.12-.87s0-.13-.5-.14c-.12.24,0,.29-.27.46.07-.32,0-.1,0-.2-.25.06-.15.07-.34.2,0-.31-.08-.26-.34-.13.05.2,0,.14.2.2a.8.8,0,0,0-.14.41l-.39-.34c-.18.35,0,.23-.26.42l-.09,0a1.13,1.13,0,0,0-.2.13c.1.37.18.07.07.34-.23,0-.25.1-.41.31l0,0-.05.06-.11.1c-.1.09-.22.13-.25.33a.6.6,0,0,0,.17.39c-.15.18-.13.12-.14.41l-.29-.1c-.31-.07-.15.16-.24-.1h-.34c0,.45-.17.34-.07.54s.25.17.41.4c-.17.07-.06.05-.27,0,0,.35.08.12,0,.47-.21-.14-.1-.11-.34-.54s-.25-.15-.21-.61c-.28.08-.26.22-.4.41l-.32.35a1.17,1.17,0,0,0-.27.53c0,.2.12.31.12.67,0,0,0,0,0,0l.18,0c0,.14,0,.08-.1.17l-.06.07c-.1.11,0,0-.11.1l-.11.09,0,0-.08.06c-.17.14-.13.16-.21.34l0,.09c-.41,1.07-.65,1.07-1.86,1.52-.23.08,0,.05-.25.07s-.17-.16-.45,0-.05.16-.27.34-.39-.11-1,.53a.55.55,0,0,1-.42.17c-.35,0-.09-.2-.54.1,0-.36.07-.13-.13-.21-.06.22-.05.18-.23.32-.4.31-.08-.09-.66.55l-.07.07-.21.26-.06.08c-.32.36-1,.21-1,1.29h-.2a4.77,4.77,0,0,1-.07-.74,1.54,1.54,0,0,0-.48,1.2c.22.08.06-.11.18.17a.92.92,0,0,1-.05.83,1.09,1.09,0,0,0-.13.37v.49c0,.15.06.1.22.29s.05.25.35.6l0,0,.17.23c.26.35.37.17.37,1h-.14a1.09,1.09,0,0,0-.74-.89c0,.63.17.21.21.68-.16-.1-.07-.08-.27-.13,0,.35.06.12-.14.2.44.65,1.12.9,1.29,1.74.07.38.47.57.61.89s0,0,.11.22.13.12.21.2a1,1,0,0,1,.22.58c.23,1.43,1.1,1.73,1.19,2.58v.5c-.05.3,0,.25.11.55s0,.39-.1.62a1.53,1.53,0,0,1-.4-.06c0,.49,0,.93.42.92s.76.7,1.7.54a3.55,3.55,0,0,0,1-.13c.27-.16.3-.32.4-.43l0,0,.1-.1.06-.07.2-.12c.15,0,.4,0,.47-.24,0,0,0-.11,0-.13.1-.38.64-.37,1-.48l.77-.11h.16c.25,0-.07,0,.18,0l.1,0,0,0c.24.1-.18.06.25.09.06-.15.14-.23.56-.22s.79.21,1-.71a.65.65,0,0,1,.13-.34c.17-.2.27-.11.54-.27,1.08-.62.66-.73,1.88-.75a3.48,3.48,0,0,0,1.29-.4c.8-.32.72-.54,1.95-.54a3.1,3.1,0,0,0,.78-.11c.29-.05.89.42,1.12.57.39-.1.18-.28.66,0,.28.17.48.11.82.19.09.21,0,0,0,.34.22-.05.22-.09.41,0-.06.14-.13.1-.17.24l.14.39c.17.15.3,0,.47.21a4.11,4.11,0,0,0,.35.59,1.11,1.11,0,0,1,.22.66s0,0,0,0h-.07l-.17.17c.41,0,.3.3.67.39.13,0,0,0,.14,0s0,0,.14.06l-.05-.27c0-.21,0-.27.4-.73s.71-.32.9-.66a1.72,1.72,0,0,1,.3-.51c.17-.18,0,.07.15-.19,0,0,0,0,0,0l.06.08a1.16,1.16,0,0,1,.11.16c-.2,0-.17,0-.27.13.14.31.15.27,0,.45a1.6,1.6,0,0,0-.34,1.06c0,.4-.09.31-.47.31-.06.25-.11.19-.14.48a1.53,1.53,0,0,0,.48-.14c.29-.07.32.16.48-.2l.27-.81.13.21a.11.11,0,0,1,0,0l0,.08,0,0c.38.77-.24.79-.28,1.23a2.21,2.21,0,0,0,.67-.13s0,0,0,0,0,0,0,0c.42.36.87.82.68,1.44,0,0,0,0,0,0l0,.34a1.17,1.17,0,0,0,.29.42l.27.46c.21.22.52.13.76.39l.19.22c.2-.07.2-.15.41-.09l.14.06.06,0c.18.05.09,0,.26.08s.69.39.75.54c.38,0,1.1-1,1.28-.27.34,0,.35-.24.62-.27l0,.09c-.09.2-.05-.12-.09.25l.32.28.09.1.21.08a.56.56,0,0,1,.12.28.33.33,0,0,0,.2-.48c.8,0,1-.79,1.87-.76.55,0,1,.19,1.37-.13l.14-.18c.1-.24,0-.3,0-.51l.36-1a1.32,1.32,0,0,1,.71-.87c.2-.17,0-.05.07-.18v0l0-.18a1.36,1.36,0,0,1,.37-.64c.4-.33.23-.56.83-1.2l.38-.22.05,0,.14-.1C54.48,166.19,54.39,165.72,54.3,165.26Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.55,149.54Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37,153.87a7.2,7.2,0,0,0-.69-.67,10.32,10.32,0,0,0-1-.68,2.41,2.41,0,0,0-.53-.2.91.91,0,0,0-.33,0,2.32,2.32,0,0,1,.57-.64,1.91,1.91,0,0,0,.74-1c.12-.39.23-.78.34-1.17l0,0c-.17.11-.34.22-.52.32s-.66.36-1,.56a2.81,2.81,0,0,0-.82.79,1.19,1.19,0,0,0-.16.82c0,.2-.09.21-.09.21a1.42,1.42,0,0,0-.6.35c-.24.21-.49.41-.72.64a.59.59,0,0,0-.18.36,1.11,1.11,0,0,1-.28.61,3.21,3.21,0,0,0-.6,1.28c0,.16,0,.23.22.19a.48.48,0,0,0,.54.21.12.12,0,0,1,.08,0c.35.17.51.14.84-.18a1.38,1.38,0,0,0,.22-.26c.17-.24.43-.26.68-.33a2,2,0,0,0,.83-.33s.19-.16.27,0a2.24,2.24,0,0,1,.33.43,2,2,0,0,1,.16.64,4,4,0,0,0,.23,1.23,1.34,1.34,0,0,0,1.55.82,2.5,2.5,0,0,1,1.33,0l.26.11-.5,0c-.08,0-.12,0-.16.1-.24.56-.47,1.12-.74,1.66-.18.35-.43.65-.64,1s-.31.43-.16.67a1.17,1.17,0,0,0,.93.66l.69,0a1.05,1.05,0,0,0,.8-.58.39.39,0,0,0-.1-.38.34.34,0,0,1-.35.21.62.62,0,0,0-.22.1c0-.15.14-.15.27-.19l0-.29s-.07,0-.08,0c-.15.19-.22.22-.45.15l-.19-.06c-.2-.06-.23,0-.25.15s0,.09,0,.16a.42.42,0,0,1,0-.54c.25-.31.51-.62.79-.91a10.63,10.63,0,0,0,1.58-2.12,1,1,0,0,0,.15-.39.75.75,0,0,0-.37-.79,6.22,6.22,0,0,0-1-.57.68.68,0,0,1-.41-.8l.08.26c.08.24.31.31.5.42s.62.3.92.47a.92.92,0,0,1,.3,1.49c-.17.26-.32.53-.48.79-.06.1-.06.16.09.18.54.1,1.07.25,1.62.31a7.39,7.39,0,0,0,1.33,0,14.47,14.47,0,0,0,2.42-.51,3.58,3.58,0,0,1,1.42-.08h.1c0-.26,0-.51-.08-.76l-.06-.64a5.08,5.08,0,0,0-.5-2.06c-.06-.11-.14-.2-.22-.32a1.44,1.44,0,0,1,.47.41,2.5,2.5,0,0,1,.37,1c.13.62.2,1.24.31,1.86a6.93,6.93,0,0,0,.56,2,3.6,3.6,0,0,0,1.27,1.46c.61.38,1.26.71,1.91,1s1.09.5,1.65.73,1.39.53,2.09.79l1,.37a.57.57,0,0,1,.4.38l-.55-.28,0,0c0,.19.12.39.16.58.11.53.2,1.05.29,1.58s.14.82.19,1.23c0,.23,0,.46,0,.68a1.48,1.48,0,0,0,.32.95l.22.2a7.09,7.09,0,0,1,1.17,1.45,1.32,1.32,0,0,0,.41.37h.33a.13.13,0,0,0,0-.09.4.4,0,0,1,0-.52,1.69,1.69,0,0,0,.15-.37c0-.22-.11-.37-.22-.54s-.09-.11-.13-.16l-.28.35h0a.64.64,0,0,0,.1-.72,1.18,1.18,0,0,0-.45-.62,1.09,1.09,0,0,1-.53-.91c-.08-.47-.12-1-.17-1.42a5.69,5.69,0,0,1-.06-.83c0-.4.09-.8.11-1.2a.86.86,0,0,0-.24-.64,5.17,5.17,0,0,0-1.1-.82c-.7-.49-1.4-1-2.06-1.49A9.51,9.51,0,0,1,51,158.94a3.06,3.06,0,0,1-.38-1.15,2,2,0,0,1,.12-1,4.25,4.25,0,0,0,.23,1.69c.36-.1.69-.23.75-.63a2.57,2.57,0,0,0,0-.73c0-.22.08-.35.3-.3a1.1,1.1,0,0,1,.7.54c.56.82,1.09,1.66,1.63,2.5.32.51.64,1,1,1.52.45.67.92,1.34,1.4,2,.26.35.56.67.85,1s.56.56.84.83a10.56,10.56,0,0,0,1.81,1.38,10.35,10.35,0,0,0,2.6,1.13,17.74,17.74,0,0,0,1.92.42,8.82,8.82,0,0,0,1.62.1,10.94,10.94,0,0,0,1.71-.21,9.36,9.36,0,0,0,2.56-.88,13,13,0,0,0,1.13-.68s.07,0,.07-.07a2,2,0,0,0,0-.26.58.58,0,0,0-.22,0c-.2.07-.4.16-.6.25a12,12,0,0,1-2.17.79,9.78,9.78,0,0,1-1.51.28,11.64,11.64,0,0,1-1.67,0,7,7,0,0,1-2.87-.82,8.33,8.33,0,0,1-1.93-1.34c-.22-.2-.44-.4-.65-.61a15.12,15.12,0,0,1-1.53-1.86,29.09,29.09,0,0,1-1.61-2.67c-.37-.66-.72-1.33-1.08-2a19.28,19.28,0,0,0-1.76-2.76,11.44,11.44,0,0,0-1.39-1.48,7.89,7.89,0,0,0-3.84-1.85,11.13,11.13,0,0,0-1.41-.2c-.81,0-1.63-.08-2.44-.06a13.71,13.71,0,0,0-3.48.48,9.5,9.5,0,0,0-2,1,4.76,4.76,0,0,1-1.37.6,1.65,1.65,0,0,1-.38,0,7.31,7.31,0,0,0-.81,0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.69,143.19h-.55v1.54h-.31v-1.54h-.55v-.32h1.41Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.68,142.87v1.86h-.31v-1.32l-.62,1-.61-1v1.32h-.32v-1.86h.35l.58.9.59-.9Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.67,147.69v.6a4.29,4.29,0,0,0-1.06-.57,3.86,3.86,0,0,0-1.37-.22,4.18,4.18,0,0,0-1.6.3,3.92,3.92,0,0,0-2.4,3.65,3.94,3.94,0,0,0,.3,1.53,3.86,3.86,0,0,0,2.1,2.1,4,4,0,0,0,1.6.31h.16a4.12,4.12,0,0,0,1.61-.31V153h0a2.16,2.16,0,0,1-.74.47,2.35,2.35,0,0,1-.87.16,2.22,2.22,0,0,1-.37,0h0a1.91,1.91,0,0,1-.51-.13,2,2,0,0,1-.73-.47,2,2,0,0,1-.66-1.51,2,2,0,0,1,.66-1.53,2.32,2.32,0,0,1,.73-.46,2.38,2.38,0,0,1,.88-.17,2.25,2.25,0,0,1,1.61.63,2,2,0,0,1,.66,1.53v3.94h1.89v-7.7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.66,155.39l-4.19-4v4H62.58V144.73h1.89v4l4.19-4h2.68l-5.53,5.31,5.53,5.34Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.48,147.5a3.53,3.53,0,0,1,1.4.27,3.23,3.23,0,0,1,1.08.77,3.53,3.53,0,0,1,.7,1.13,3.93,3.93,0,0,1,.24,1.38v4.34H85v-4.34a1.6,1.6,0,0,0-.55-1.25,1.91,1.91,0,0,0-2.6,0,1.66,1.66,0,0,0-.54,1.25v4.34H79.43v-7.68h1.89v.57a3.81,3.81,0,0,1,1-.57A3.29,3.29,0,0,1,83.48,147.5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.12,147.71a3.38,3.38,0,0,1,1.27-.23v1.8a2.25,2.25,0,0,0-1.61.63,2.1,2.1,0,0,0-.66,1.53v3.95h-1.89v-7.7h1.89v.59A4.07,4.07,0,0,1,109.12,147.71Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.67,147.5a4.32,4.32,0,0,1,1.62.3,4.26,4.26,0,0,1,1.33.85,4,4,0,0,1,.89,1.26,3.84,3.84,0,0,1,0,3.07,3.85,3.85,0,0,1-.89,1.25,4.09,4.09,0,0,1-1.33.85,4.39,4.39,0,0,1-3.24,0,4.09,4.09,0,0,1-1.33-.85,3.85,3.85,0,0,1-.89-1.25,3.84,3.84,0,0,1,0-3.07,4,4,0,0,1,.89-1.26,4.26,4.26,0,0,1,1.33-.85A4.32,4.32,0,0,1,114.67,147.5Zm0,1.79a2.25,2.25,0,0,0-1.61.63,2,2,0,0,0-.66,1.53,2.17,2.17,0,0,0,1.4,2,2.28,2.28,0,0,0,.87.16,2.32,2.32,0,0,0,.87-.16,2.16,2.16,0,0,0,.74-.47,2,2,0,0,0,.66-1.51,2,2,0,0,0-.66-1.53A2.32,2.32,0,0,0,114.67,149.29Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.52,147.5a4.41,4.41,0,0,1,1.63.3,4.34,4.34,0,0,1,1.32.85,3.85,3.85,0,0,1,.89,1.26,3.84,3.84,0,0,1,0,3.07,3.71,3.71,0,0,1-.89,1.25,4.16,4.16,0,0,1-1.32.85,4.22,4.22,0,0,1-1.63.31,4.14,4.14,0,0,1-1.62-.31,4.09,4.09,0,0,1-1.33-.85,4,4,0,0,1-.89-1.25,3.84,3.84,0,0,1,0-3.07,4.17,4.17,0,0,1,.89-1.26,4.26,4.26,0,0,1,1.33-.85A4.32,4.32,0,0,1,123.52,147.5Zm0,1.79a2.27,2.27,0,0,0-1.61.63,2,2,0,0,0-.66,1.53,2.17,2.17,0,0,0,1.4,2,2.35,2.35,0,0,0,.87.16,2.28,2.28,0,0,0,.87-.16,2.16,2.16,0,0,0,.74-.47,2,2,0,0,0,.66-1.51,2,2,0,0,0-.66-1.53A2.32,2.32,0,0,0,123.52,149.29Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.29,147.69v.6a4.12,4.12,0,0,0-1.06-.57,3.86,3.86,0,0,0-1.37-.22,4.18,4.18,0,0,0-1.6.3,3.92,3.92,0,0,0-2.4,3.65,3.94,3.94,0,0,0,.3,1.53,3.86,3.86,0,0,0,2.1,2.1,4,4,0,0,0,1.6.31H101a4.21,4.21,0,0,0,1.62-.31V153h0a2.16,2.16,0,0,1-.74.47,2.4,2.4,0,0,1-1.24.13h0a1.76,1.76,0,0,1-.5-.13,2.17,2.17,0,0,1-1.4-2,2,2,0,0,1,.66-1.53,2.25,2.25,0,0,1,.74-.46,2.32,2.32,0,0,1,.87-.17,2.25,2.25,0,0,1,1.61.63,2,2,0,0,1,.66,1.53v3.94h1.89v-7.7Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.12,147.69v.6a4.12,4.12,0,0,0-1.06-.57,3.56,3.56,0,0,0-.68-.17,5.09,5.09,0,0,0-.81-.07,4,4,0,0,0-1.57.31,3.57,3.57,0,0,0-1.23.85,3.88,3.88,0,0,0-.8,1.25,4.18,4.18,0,0,0-.28,1.55h0A3.94,3.94,0,0,0,88,153a3.86,3.86,0,0,0,2.1,2.1,4,4,0,0,0,1.6.31H92a4.18,4.18,0,0,0,1.5-.3V153h0a2.16,2.16,0,0,1-.74.47,2.4,2.4,0,0,1-1.24.13h0a1.76,1.76,0,0,1-.5-.13,2.17,2.17,0,0,1-1.4-2,1.89,1.89,0,0,1,.16-.79.14.14,0,0,1,0-.06,2.07,2.07,0,0,1,.48-.67,2.25,2.25,0,0,1,.74-.46,2.32,2.32,0,0,1,.87-.17,2.25,2.25,0,0,1,1.61.63,2.07,2.07,0,0,1,.48.67l0,.06a2.07,2.07,0,0,1,.15.8v3a2,2,0,0,1-.66,1.52,2.19,2.19,0,0,1-1.61.64,2.15,2.15,0,0,1-1.13-.3l-1.38,1.29a4.32,4.32,0,0,0,1.17.6,4.23,4.23,0,0,0,1.34.21,4.14,4.14,0,0,0,1.62-.32,4.26,4.26,0,0,0,1.33-.85,4,4,0,0,0,.89-1.26,3.78,3.78,0,0,0,.32-1.53v-6.75Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.77,161.9v.5H62.58v-2.86h2.11v.5H63.14v.73h1.3v.48h-1.3v.65Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.4,159.3v3.06h-.57v-.13a1.35,1.35,0,0,1-.64.17,1.14,1.14,0,0,1,0-2.28,1.32,1.32,0,0,1,.64.16v-1Zm-.57,2.4v-.89a.84.84,0,0,0-.54-.19.64.64,0,0,0-.66.64.63.63,0,0,0,.66.63A.86.86,0,0,0,67.83,161.7Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72,160.16v2.21h-.56v-.15a1.12,1.12,0,0,1-.61.18c-.64,0-.94-.3-.94-1v-1.22h.57v1.22c0,.35.16.51.48.51a.76.76,0,0,0,.5-.17v-1.56Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.49,162a1.07,1.07,0,0,1-.86.44,1.14,1.14,0,1,1,0-2.28,1.07,1.07,0,0,1,.87.44l-.37.34a.58.58,0,0,0-.5-.27.63.63,0,1,0,0,1.26.58.58,0,0,0,.5-.27Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.11,160.16v2.21h-.57v-.17a1.08,1.08,0,0,1-.64.2,1.14,1.14,0,0,1,0-2.28,1.26,1.26,0,0,1,.64.18v-.14Zm-.57.66a.81.81,0,0,0-.54-.19.63.63,0,1,0,0,1.26.85.85,0,0,0,.54-.18Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.32,160.63v.78c0,.39.07.51.35.51l.26,0v.42a1.3,1.3,0,0,1-.51.08.64.64,0,0,1-.67-.69v-1.08h-.31v-.47h.31v-.86h.57v.86h.62v.47Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.29,159.63a.33.33,0,0,1,.32-.34.33.33,0,0,1,.32.34.32.32,0,0,1-.32.32A.32.32,0,0,1,83.29,159.63Zm0,.56h.57v2.21h-.57Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.74,161.26a1.21,1.21,0,1,1-1.2-1.14A1.17,1.17,0,0,1,87.74,161.26Zm-.55,0a.65.65,0,1,0-.65.63A.64.64,0,0,0,87.19,161.26Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.26,161.17v1.23H90.7v-1.23c0-.34-.17-.51-.48-.51a.72.72,0,0,0-.49.18v1.56h-.57v-2.21h.57v.14a1,1,0,0,1,.59-.18C91,160.15,91.26,160.45,91.26,161.17Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.69,160v1h1.37v.5H95.69v.84h-.56v-2.86h2.16v.5Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.93,161.26a1.21,1.21,0,1,1-1.2-1.14A1.17,1.17,0,0,1,100.93,161.26Zm-.55,0a.65.65,0,1,0-.65.63A.64.64,0,0,0,100.38,161.26Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.44,160.16v2.21h-.56v-.15a1.12,1.12,0,0,1-.61.18c-.64,0-.94-.3-.94-1v-1.22h.57v1.22c0,.35.16.51.48.51a.76.76,0,0,0,.5-.17v-1.56Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.06,161.17v1.23h-.56v-1.23c0-.34-.17-.51-.48-.51a.74.74,0,0,0-.49.18v1.56H106v-2.21h.56v.14a1.08,1.08,0,0,1,.59-.18C107.77,160.15,108.06,160.45,108.06,161.17Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.79,159.3v3.06h-.56v-.13a1.4,1.4,0,0,1-.65.17,1.14,1.14,0,0,1,0-2.28,1.39,1.39,0,0,1,.65.16v-1Zm-.56,2.4v-.89a.89.89,0,0,0-.55-.19.63.63,0,0,0-.65.64.62.62,0,0,0,.65.63A.89.89,0,0,0,111.23,161.7Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.53,160.16v2.21H115v-.17a1.14,1.14,0,0,1-.65.2,1.14,1.14,0,0,1,0-2.28,1.32,1.32,0,0,1,.65.18v-.14Zm-.56.66a.85.85,0,0,0-.55-.19.63.63,0,1,0,0,1.26.88.88,0,0,0,.55-.18Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.75,160.63v.78c0,.39.06.51.35.51l.26,0v.42a1.44,1.44,0,0,1-.52.08.63.63,0,0,1-.66-.69v-1.08h-.32v-.47h.32v-.86h.57v.86h.61v.47Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.71,159.63a.34.34,0,0,1,.33-.34.33.33,0,0,1,.32.34.32.32,0,0,1-.32.32A.32.32,0,0,1,119.71,159.63Zm.05.56h.56v2.21h-.56Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.17,161.26a1.21,1.21,0,1,1-1.21-1.14A1.18,1.18,0,0,1,124.17,161.26Zm-.56,0a.65.65,0,1,0-.65.63A.64.64,0,0,0,123.61,161.26Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.68,161.17v1.23h-.56v-1.23c0-.34-.17-.51-.48-.51a.74.74,0,0,0-.49.18v1.56h-.56v-2.21h.56v.14a1.06,1.06,0,0,1,.59-.18C127.39,160.15,127.68,160.45,127.68,161.17Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.34,186.83v-7.5h3a2.26,2.26,0,1,1,0,4.52h-2.08v3Zm4.4-5.24a1.4,1.4,0,0,0-1.5-1.43h-2V183h2A1.4,1.4,0,0,0,196.74,181.59Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.91,186.83V181.4h.84v.86a2.34,2.34,0,0,1,1.81-1v.86l-.32,0a2,2,0,0,0-1.49.86v3.85Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.31,184.11a2.71,2.71,0,0,1,2.67-2.85,2.64,2.64,0,0,1,2.61,2.92v.21h-4.38a1.9,1.9,0,0,0,1.94,1.88,2.38,2.38,0,0,0,1.69-.7l.4.55a3,3,0,0,1-2.15.85A2.7,2.7,0,0,1,202.31,184.11ZM205,182a1.8,1.8,0,0,0-1.77,1.8h3.56A1.76,1.76,0,0,0,205,182Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.5,186.11l.42-.61a2.46,2.46,0,0,0,1.79.78c.83,0,1.29-.39,1.29-.93,0-1.32-3.36-.51-3.36-2.52,0-.86.72-1.57,2-1.57a2.72,2.72,0,0,1,2,.79l-.4.59a2.07,2.07,0,0,0-1.62-.69c-.74,0-1.2.37-1.2.85,0,1.19,3.36.41,3.36,2.52,0,.91-.73,1.65-2.12,1.65A2.92,2.92,0,0,1,208.5,186.11Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.87,184.11a2.72,2.72,0,0,1,2.68-2.85,2.65,2.65,0,0,1,2.61,2.92v.21h-4.39a1.91,1.91,0,0,0,1.95,1.88,2.34,2.34,0,0,0,1.68-.7l.41.55a3,3,0,0,1-2.16.85A2.7,2.7,0,0,1,213.87,184.11Zm2.67-2.15a1.82,1.82,0,0,0-1.78,1.8h3.57A1.77,1.77,0,0,0,216.54,182Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.2,186.83v-3.55c0-1-.5-1.26-1.23-1.26a2.12,2.12,0,0,0-1.61.84v4h-.84V181.4h.84v.79a2.66,2.66,0,0,1,1.95-.93A1.55,1.55,0,0,1,225,183v3.81Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.9,185.69v-3.55H226v-.74h.9v-1.49h.86v1.49h1.1v.74h-1.1v3.37c0,.41.17.7.53.7a.82.82,0,0,0,.58-.23l.25.64a1.4,1.4,0,0,1-1,.35A1.12,1.12,0,0,1,226.9,185.69Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.43,186.83v-.62a2.29,2.29,0,0,1-1.79.76,1.8,1.8,0,0,1-1.89-1.8,1.76,1.76,0,0,1,1.89-1.79,2.25,2.25,0,0,1,1.79.73v-1c0-.72-.58-1.14-1.37-1.14a2.11,2.11,0,0,0-1.66.76l-.39-.59a2.86,2.86,0,0,1,2.17-.9c1.15,0,2.1.52,2.1,1.84v3.73Zm0-1.15v-1A1.8,1.8,0,0,0,232,184a1.2,1.2,0,1,0,0,2.37A1.79,1.79,0,0,0,233.43,185.68Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.15,185.69v-3.55h-.9v-.74h.9v-1.49H237v1.49h1.1v.74H237v3.37c0,.41.18.7.54.7a.84.84,0,0,0,.58-.23l.24.64a1.36,1.36,0,0,1-1,.35A1.12,1.12,0,0,1,236.15,185.69Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.14,180.06a.58.58,0,0,1,.57-.57.57.57,0,0,1,.57.57.56.56,0,0,1-.57.56A.56.56,0,0,1,239.14,180.06Zm.15,6.77V181.4h.84v5.43Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.5,184.11a2.7,2.7,0,1,1,2.69,2.86A2.67,2.67,0,0,1,241.5,184.11Zm4.49,0a1.82,1.82,0,1,0-1.8,2.1A1.89,1.89,0,0,0,246,184.11Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.93,186.83v-3.55c0-1-.49-1.26-1.23-1.26a2.09,2.09,0,0,0-1.6.84v4h-.85V181.4h.85v.79a2.62,2.62,0,0,1,1.94-.93,1.54,1.54,0,0,1,1.72,1.76v3.81Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.41,186.83v-7.5H260a3.75,3.75,0,1,1,0,7.5Zm5.44-3.74a2.75,2.75,0,0,0-2.88-2.93h-1.63V186H260A2.76,2.76,0,0,0,262.85,183.09Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.65,186.83v-.62a2.33,2.33,0,0,1-1.8.76,1.81,1.81,0,0,1-1.89-1.8,1.76,1.76,0,0,1,1.89-1.79,2.29,2.29,0,0,1,1.8.73v-1c0-.72-.59-1.14-1.37-1.14a2.13,2.13,0,0,0-1.67.76l-.39-.59a2.86,2.86,0,0,1,2.17-.9c1.16,0,2.1.52,2.1,1.84v3.73Zm0-1.15v-1a1.84,1.84,0,0,0-1.49-.66,1.2,1.2,0,1,0,0,2.37A1.82,1.82,0,0,0,268.65,185.68Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.36,185.69v-3.55h-.9v-.74h.9v-1.49h.86v1.49h1.1v.74h-1.1v3.37c0,.41.18.7.54.7a.81.81,0,0,0,.57-.23l.25.64a1.39,1.39,0,0,1-1,.35A1.12,1.12,0,0,1,271.36,185.69Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.18,184.11a2.72,2.72,0,0,1,2.68-2.85,2.65,2.65,0,0,1,2.61,2.92v.21h-4.39a1.91,1.91,0,0,0,1.95,1.88,2.38,2.38,0,0,0,1.69-.7l.4.55A3,3,0,0,1,277,187,2.7,2.7,0,0,1,274.18,184.11Zm2.67-2.15a1.82,1.82,0,0,0-1.78,1.8h3.57A1.76,1.76,0,0,0,276.85,182Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.34,263.45V256h3a2.26,2.26,0,1,1,0,4.52h-2.08v3Zm4.4-5.24a1.39,1.39,0,0,0-1.5-1.43h-2v2.85h2A1.39,1.39,0,0,0,196.74,258.21Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.91,263.45V258h.84v.87a2.35,2.35,0,0,1,1.81-1v.87a2.91,2.91,0,0,0-.32,0,2,2,0,0,0-1.49.87v3.85Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.31,260.72a2.71,2.71,0,0,1,2.67-2.84,2.63,2.63,0,0,1,2.61,2.91V261h-4.38a1.89,1.89,0,0,0,1.94,1.87,2.37,2.37,0,0,0,1.69-.69l.4.55a3,3,0,0,1-2.15.84A2.7,2.7,0,0,1,202.31,260.72Zm2.66-2.14a1.8,1.8,0,0,0-1.77,1.8h3.56A1.76,1.76,0,0,0,205,258.58Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.5,262.73l.42-.61a2.45,2.45,0,0,0,1.79.77c.83,0,1.29-.39,1.29-.93,0-1.31-3.36-.5-3.36-2.52,0-.85.72-1.56,2-1.56a2.72,2.72,0,0,1,2,.79l-.4.58a2.1,2.1,0,0,0-1.62-.68c-.74,0-1.2.37-1.2.85,0,1.18,3.36.41,3.36,2.52,0,.91-.73,1.64-2.12,1.64A2.92,2.92,0,0,1,208.5,262.73Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.87,260.72a2.72,2.72,0,0,1,2.68-2.84,2.64,2.64,0,0,1,2.61,2.91V261h-4.39a1.9,1.9,0,0,0,1.95,1.87,2.33,2.33,0,0,0,1.68-.69l.41.55a3,3,0,0,1-2.16.84A2.7,2.7,0,0,1,213.87,260.72Zm2.67-2.14a1.82,1.82,0,0,0-1.78,1.8h3.57A1.77,1.77,0,0,0,216.54,258.58Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.2,263.45v-3.56c0-1-.5-1.26-1.23-1.26a2.13,2.13,0,0,0-1.61.85v4h-.84V258h.84v.79a2.69,2.69,0,0,1,1.95-.92,1.54,1.54,0,0,1,1.72,1.75v3.82Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.9,262.31v-3.55H226V258h.9v-1.48h.86V258h1.1v.75h-1.1v3.37c0,.41.17.7.53.7a.78.78,0,0,0,.58-.24l.25.64a1.4,1.4,0,0,1-1,.35A1.11,1.11,0,0,1,226.9,262.31Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.72,260.72a2.72,2.72,0,0,1,2.68-2.84,2.64,2.64,0,0,1,2.61,2.91V261h-4.39a1.9,1.9,0,0,0,1.95,1.87,2.37,2.37,0,0,0,1.69-.69l.4.55a3,3,0,0,1-2.16.84A2.7,2.7,0,0,1,229.72,260.72Zm2.67-2.14a1.82,1.82,0,0,0-1.78,1.8h3.57A1.76,1.76,0,0,0,232.39,258.58Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.31,263.45v-.81a2.29,2.29,0,0,1-1.83.94c-1.42,0-2.42-1.08-2.42-2.84s1-2.86,2.42-2.86a2.26,2.26,0,0,1,1.83,1V256h.84v7.5Zm0-1.49v-2.45a2,2,0,0,0-1.62-.88c-1.1,0-1.76.9-1.76,2.11s.66,2.09,1.76,2.09A2,2,0,0,0,240.31,262Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.76,263.45V256h.84v2.89a2.26,2.26,0,0,1,1.83-1c1.43,0,2.42,1.11,2.42,2.86s-1,2.84-2.42,2.84a2.28,2.28,0,0,1-1.83-.94v.81Zm2.47-.62c1.09,0,1.74-.89,1.74-2.09s-.65-2.11-1.74-2.11a2,2,0,0,0-1.63.88V262A2,2,0,0,0,248.23,262.83Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.06,264.81a1.39,1.39,0,0,0,.46.09.79.79,0,0,0,.81-.58l.36-.82L251.42,258h.92l1.8,4.46L256,258h.91l-2.72,6.54a1.61,1.61,0,0,1-1.6,1.1,2.37,2.37,0,0,1-.61-.08Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.57,258.55a.62.62,0,0,1,.62-.61.63.63,0,0,1,.62.61.64.64,0,0,1-.62.62A.63.63,0,0,1,257.57,258.55Zm0,4.39a.62.62,0,0,1,.62-.62.62.62,0,0,1,0,1.24A.62.62,0,0,1,257.57,262.94Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 567.05,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 319.02,
    x2: 567.05,
    y2: 319.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 319.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 319.02,
    y1: 0.13,
    x2: 319.02,
    y2: 319.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 32.02,
    y1: 0.13,
    x2: 32.02,
    y2: 319.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 63.9,
    y1: 0.13,
    x2: 63.9,
    y2: 319.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 95.79,
    y1: 0.13,
    x2: 95.79,
    y2: 319.02
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.68,
    y1: 0.13,
    x2: 127.68,
    y2: 319.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 159.57,
    y1: 0.13,
    x2: 159.57,
    y2: 319.02
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191.46,
    y1: 0.13,
    x2: 191.46,
    y2: 319.02
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 223.35,
    y1: 0.13,
    x2: 223.35,
    y2: 319.02
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 255.24,
    y1: 0.13,
    x2: 255.24,
    y2: 319.02
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 287.13,
    y1: 0.13,
    x2: 287.13,
    y2: 319.02
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.07,
    y1: 0.13,
    x2: 16.07,
    y2: 319.02
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 47.96,
    y1: 0.13,
    x2: 47.96,
    y2: 319.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 79.85,
    y1: 0.13,
    x2: 79.85,
    y2: 319.02
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.74,
    y1: 0.13,
    x2: 111.74,
    y2: 319.02
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 143.63,
    y1: 0.13,
    x2: 143.63,
    y2: 319.02
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 175.52,
    y1: 0.13,
    x2: 175.52,
    y2: 319.02
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 207.41,
    y1: 0.13,
    x2: 207.41,
    y2: 319.02
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 239.3,
    y1: 0.13,
    x2: 239.3,
    y2: 319.02
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 271.19,
    y1: 0.13,
    x2: 271.19,
    y2: 319.02
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 303.08,
    y1: 0.13,
    x2: 303.08,
    y2: 319.02
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 287.13,
    x2: 567.05,
    y2: 287.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 255.24,
    x2: 567.05,
    y2: 255.24
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 223.35,
    x2: 567.05,
    y2: 223.35
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 191.46,
    x2: 567.05,
    y2: 191.46
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 159.57,
    x2: 567.05,
    y2: 159.57
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 127.68,
    x2: 567.05,
    y2: 127.68
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 95.79,
    x2: 567.05,
    y2: 95.79
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 63.9,
    x2: 567.05,
    y2: 63.9
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 32.01,
    x2: 567.05,
    y2: 32.01
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 303.08,
    x2: 567.05,
    y2: 303.08
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 271.19,
    x2: 567.05,
    y2: 271.19
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 239.3,
    x2: 567.05,
    y2: 239.3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 207.41,
    x2: 567.05,
    y2: 207.41
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 175.52,
    x2: 567.05,
    y2: 175.52
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 143.63,
    x2: 567.05,
    y2: 143.63
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 111.74,
    x2: 567.05,
    y2: 111.74
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 79.85,
    x2: 567.05,
    y2: 79.85
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 47.96,
    x2: 567.05,
    y2: 47.96
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 16.07,
    x2: 567.05,
    y2: 16.07
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 350.91,
    y1: 0.13,
    x2: 350.91,
    y2: 319.02
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 382.8,
    y1: 0.13,
    x2: 382.8,
    y2: 319.02
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 414.69,
    y1: 0.13,
    x2: 414.69,
    y2: 319.02
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 446.58,
    y1: 0.13,
    x2: 446.58,
    y2: 319.02
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 478.47,
    y1: 0.2,
    x2: 478.47,
    y2: 319.09
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 334.97,
    y1: 0.13,
    x2: 334.97,
    y2: 319.02
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 366.86,
    y1: 0.13,
    x2: 366.86,
    y2: 319.02
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 398.75,
    y1: 0.13,
    x2: 398.75,
    y2: 319.02
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 430.64,
    y1: 0.13,
    x2: 430.64,
    y2: 319.02
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 462.53,
    y1: 0.13,
    x2: 462.53,
    y2: 319.02
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 510.36,
    y1: 0.13,
    x2: 510.36,
    y2: 319.02
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 542.25,
    y1: 0.13,
    x2: 542.25,
    y2: 319.02
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 494.42,
    y1: 0.13,
    x2: 494.42,
    y2: 319.02
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 526.31,
    y1: 0.13,
    x2: 526.31,
    y2: 319.02
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 558.19,
    y1: 0.13,
    x2: 558.19,
    y2: 319.02
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 318.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial8);
export default __webpack_public_path__ + "static/media/guideMaterial8.79e0a37358766d78d7f10080d2ef1f8d.svg";
export { ForwardRef as ReactComponent };